import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const MediaContent = ({
  key,
  heading=null,
  content=null,
  mediaPosition="left",
  mediaPositionVertical="center",
  pattern="orangeHexDots",
  type="image",
  imageLink=null,
  image=null,
  imageList=null,
  buttons=null,
  video=null
}) => {
  let patternCode = 'dot-pattern'
  if (pattern === 'blueHexDots') {
    patternCode = 'line-dot-pattern'
  } else if (pattern === 'orangeHexLines') {
    patternCode = 'line-pattern'
  }

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <>
      <div className={ `media_block media-item ${type} media-item--${patternCode} media-item--${mediaPosition}` }>
        <div className="container">
          <div className={ `row v-align-${mediaPositionVertical}` }>
            <div className={ `${mediaPosition === 'left' ? "order-1 mwc-content col-xs-12 col-md-6 col-lg-5" : "order-0 mwc-content col-xs-12 col-md-6 col-lg-5"}` }>
              <div className="bfc offset-lg-2">
                {heading &&
                  <h2 className={ `content-title ${content ? "orange-dash" : ""}` }>{ htmlDecode(heading) }</h2>
                }
                {content &&
                  <div className="section-content" dangerouslySetInnerHTML={{ __html: content }} />
                }
                {buttons && buttons.map((button, index) => (
                  <Link href={ button.link } className={ `button ${index > 0 ? "inverse" : ""} mr2` }>{ button.text }</Link>
                ))}
              </div>
            </div>
            <div className={ `${mediaPosition === 'left' ? "mwc-media order-0 col-xs-12 col-md-6" : "mwc-media order-1 col-xs-12 col-md-6 offset-lg-1"}` }>
              {type === 'video' &&
                <>
                  {video.videoSource === 'vimeo' &&
                    <div className="img-container img-container--object-fit linked">
                      <div className="play-btn-wrap">
                        <a className="play-btn youtube-modal" data-toggle="modal" data-target={ `#video-${video.videoId}` }><span className="fa fa-play" /></a>
                      </div>
                      {video.videoThumbnail?.formats?.medium &&
                        <img className="video-thumb" src={ video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url} alt={ video.videoThumbnail?.alternativeText } />
                      }
                      {(!video.videoThumbnail?.formats?.medium && video.videoThumbnail) &&
                        <img className="video-thumb" src={ video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url} alt={ video.videoThumbnail?.alternativeText } />
                      }
                    </div>
                  } 
                  {video.videoSource === 'wistia' &&
                    <div className="img-container img-container--object-fit linked">
                      <div className={ `wistia_embed wistia_async_${video.videoId} popover=true popoverAnimateThumbnail=true popoverContent=link videoFoam=true` }>
                        <div className="play-btn-wrap"><div className="play-btn"><span className="fa fa-play" /></div></div>
                        {video.videoThumbnail?.formats?.medium &&
                          <img className="video-thumb" src={video.videoThumbnail.formats.medium.url.includes(cdnUrl) ? video.videoThumbnail.formats.medium.url : cdnUrl + video.videoThumbnail.formats.medium.url} alt={ video.videoThumbnail?.alternativeText } />
                        }
                        {!video.videoThumbnail?.formats?.medium &&
                          <img className="video-thumb" src={video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url} alt={ video.videoThumbnail?.alternativeText } />
                        }
                      </div>
                    </div>
                  }
                  {video.videoSource === 'youtube' &&
                    <div className="img-container img-container--object-fit linked">
                      <div className="play-btn-wrap">
                        <a className="play-btn youtube-modal" data-toggle="modal" data-target={ `#video-${video.videoId}` }><span className="fa fa-play" /></a>
                      </div>
                      {video.videoThumbnail?.formats?.medium &&
                        <img className="video-thumb" src={ video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url} alt={ video.videoThumbnail?.alternativeText } />
                      }
                      {(!video.videoThumbnail?.formats?.medium && video.videoThumbnail) &&
                        <img className="video-thumb" src={ video.videoThumbnail.url.includes(cdnUrl) ? video.videoThumbnail.url : cdnUrl + video.videoThumbnail.url} alt={ video.videoThumbnail?.alternativeText } />
                      }
                    </div>
                  }
                </>
              }
              {type === 'image' &&
                <>
                  {(imageLink && image) &&
                    <Link href={ imageLink } title={ image?.alternativeText }>
                      <div className="img-container linked">
                        {image.formats.large &&
                          <img className="bs1 br5" src={image.formats.large.url.includes(cdnUrl) ? image.formats.large.url : cdnUrl + image.formats.large.url} alt={ image?.alternativeText } />
                        }
                        {!image.formats.large &&
                          <img className="bs1 br5" src={image.url.includes(cdnUrl) ? image.url : cdnUrl + image.url} alt={ image?.alternativeText } />
                        }
                      </div>
                    </Link>
                  }
                  {(!imageLink && image) &&
                    <div className="img-container">
                      {image?.formats?.large &&
                        <img className="bs1 br5" src={image.formats.large.url.includes(cdnUrl) ? image.formats.large.url : cdnUrl + image.formats.large.url} alt={ image?.alternativeText } />
                      }
                      {(!image?.formats?.large && image) &&
                        <img className="bs1 br5" src={image.url.includes(cdnUrl) ? image.url : cdnUrl + image.url} alt={ image?.alternativeText } />
                      }
                    </div>
                  }
                </>
              }
              {type === 'imageList' &&
                <div className="row aife">
                  {imageList.map((item) => (
                    <div className="col-6">
                      {item.imageLink &&
                        <Link href={ item.imageLink } title={ item.image?.alternativeText }>
                          <div className="img-container">
                            {item.image?.formats?.medium &&
                              <img className="bs1 br5" src={item.image.formats.medium.url.includes(cdnUrl) ? item.image.formats.medium.url : cdnUrl + item.image.formats.medium.url} alt={ item.image?.alternativeText } />
                            }
                            {(!item.image?.formats.medium && item.image) &&
                              <img className="bs1 br5" src={item.image.url.includes(cdnUrl) ? item.image.url : cdnUrl + item.image.url} alt={ item.image?.alternativeText } />
                            }
                          </div>
                        </Link>
                      }
                      {!item.imageLink &&
                        <div className="img-container">
                          {item.image?.formats?.medium &&
                            <img className="bs1 br5" src={item.image.formats.medium.url.includes(cdnUrl) ? item.image.formats.medium.url : cdnUrl + item.image.formats.medium.url} alt={ item.image?.alternativeText } />
                          }
                          {(!item.image?.formats?.medium && item.image) &&
                            <img className="bs1 br5" src={item.image.url.includes(cdnUrl) ? item.image.url : cdnUrl + item.image.url} alt={ item.image?.alternativeText } />
                          }
                        </div>
                      }
                    </div>
                  ))}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      {type === 'video' &&
        <div className="modal fade content-video-modal" id={ `video-${video.videoId}` } tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <div className="embed-responsive embed-responsive-16by9">
                  {video.videoSource === 'youtube' &&
                    <iframe src={ `https://www.youtube.com/embed/${video.videoId}` } title={ heading } playing="true" height="720px" className="embed-responsive-item" />
                  }
                  {video.videoSource === 'vimeo' &&
                    <iframe src={`https://player.vimeo.com/video/${video.videoId}`} title={heading} width="720" frameborder="0" allow="autoplay; fullscreen" allowfullscreen className="embed-responsive-item"/>
                  } 
                  {video.videoSource === 'wistia' &&
                    <iframe src={ `https://fast.wistia.net/embed/iframe/${video.videoId}` } allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen width="720"/>
                  } 
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default MediaContent
